import { initEventsSlider } from './modules/events-slider';
import { initNewsSlider } from './modules/news-slider';
import { initPartnersSlider } from './modules/partners-slider';

document.addEventListener('DOMContentLoaded', () => {
  initEventsSlider();
  initNewsSlider();
  initPartnersSlider();
});

